export enum HeroLevel {
  None = 'None',
  Basic = 'Basic',
  Pro = 'Pro',
  Elite = 'Elite',
}
